import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import * as S from "./ModalSmartDevices.style";
import * as P from "../../../../../utils/pipes";

// Hooks
import ZaiaReaction from "../../../../zaiaComponents/zaiaReaction";
import ZaiaModalResponseContent from "../../../../zaiaComponents/zaiaModalResponseContent";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import ZaiaImage from "../../../../zaiaComponents/zaiaImage";
import useDoctorData from "../../../../../hooks/useDoctorData";
import { QUERY_GET_ALL_DEVICES, QUERY_GET_ALL_USER_TO_DEVICES, QUERY_GET_USER_TO_DEVICES } from "../../../../../graphql/queries/Devices";
import FlorenzButton from "../../../../florenzComponents/florenzButton";
import DeviceItem from "./components/deviceItem/DeviceItem";
import FlorenzSearchInput from "../../../../florenzComponents/florenceSearchInput";
import { MUTATION_DELETE_USER_TO_DEVICE_BY_DEVICE_ID, MUTATION_INSERT_USER_TO_DEVICE } from "../../../../../graphql/mutations/Devices";


// Assets
const eventsCalendarEmpty = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/no-results.svg`;
const logoZaiaLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;
const logoZaiaAlert = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-error-data.svg`;

function ModalSmartDevices({
  patientInfo,
  setModalActive
}) {

  const { t, i18n: { language } } = useTranslation("global");
  const {doctorData} = useDoctorData();
  const [devicesNotAssigned, setDevicesNotAssigned] = useState([]);

  const [currentDevices, setCurrentDevices] = useState([]);
  const [availableDevices, setAvailableDevices] = useState([]);
  const [devicesToAdd, setDevicesToAdd] = useState([]);
  const [devicesToRemove, setDevicesToRemove] = useState([]);

  const [insertUserToDevice, { loading: insertRoleAndDoctorToProcessRoleLoading }] = useMutation(MUTATION_INSERT_USER_TO_DEVICE);
  const [deleteUserToDevice, { loading: deleteUserToDeviceLoading }] = useMutation(MUTATION_DELETE_USER_TO_DEVICE_BY_DEVICE_ID);


  const { 
    data: allDevicesData,
    loading: allDevicesDataLoading,
    error: allDevicesDataError,
  } = useQuery(
    QUERY_GET_ALL_DEVICES
  );

  const { data: userDevicesData, refetch: refetchUserDevices } = useQuery(QUERY_GET_USER_TO_DEVICES, {
    variables: { 
      userId: patientInfo?.user.id
    },
  })  

  const { 
    data: allUserToDevicesData,
    loading: allUserToDevicesDataLoading,
    error: allUserToDevicesDataError,
    refetch: refetchAllUserToDevices
  } = useQuery(
    QUERY_GET_ALL_USER_TO_DEVICES
  );  
  

  useEffect(() => {
    refetchUserDevices();
    refetchAllUserToDevices();
    updateDevicesLists();
  }, []);

  const updateDevicesLists = () => {
    const allUserToDevicesDataTemp = new Set(allUserToDevicesData?.userToDevices.map(d => d.deviceId));
    const filteredDevices = allDevicesData?.getSmartmeterDevicesWithMetadata.filter(d => !allUserToDevicesDataTemp.has(d.id));  
    
    setDevicesNotAssigned(filteredDevices || []);
    setAvailableDevices(filteredDevices || []);

    setCurrentDevices(userDevicesData?.userToDevices.map(d => allDevicesData?.getSmartmeterDevicesWithMetadata.find(device => device.id === d.deviceId)) || []);
  }

  useEffect(() => {
    updateDevicesLists();
  }, [allDevicesData, allUserToDevicesData]);

  const [formSuccess, setFormSuccess] = useState(null); 
  const [inputText, setInputText] = useState('');

  const handleRemoveDevice = (device) => {
    setCurrentDevices(currentDevices.filter(d => d !== device));
    setAvailableDevices([...availableDevices, device]);
  }

  const handleAddDevice = (device) => {   
    setAvailableDevices(availableDevices.filter(d => d !== device));
    setCurrentDevices([...currentDevices, device]);
  }

  useEffect(() => {
    const deviceIdsToRemove = new Set(availableDevices.map(d => d.id));
    const filteredDevices = devicesNotAssigned.filter(d => !deviceIdsToRemove.has(d.id));

    setDevicesToAdd(filteredDevices || []);
  }, [availableDevices]);

  useEffect(() => {
    const userCurrentDevices = userDevicesData?.userToDevices.map(d => allDevicesData?.getSmartmeterDevicesWithMetadata.find(device => device.id === d.deviceId));    

    const deviceIdsToRemove = new Set(currentDevices?.map(d => d?.id));
    const filteredDevices = userCurrentDevices?.filter(d => !deviceIdsToRemove.has(d?.id));

    setDevicesToRemove(filteredDevices || []);
  }, [currentDevices]);

  const getDeviceName = (deviceType) => {
    if (!deviceType) return "";
    switch (deviceType) {
      case "blood_pressure":
        return t("profile.smartDevices.bloodPressure");
      case "pulse_ox":
        return t("profile.smartDevices.pulseOx");
      default:
        return "Device";
    }
  }

  const getFilterText = (text) => {
    return inputText 
      ? String(P.removeAccent(text)).toLowerCase().includes(P.removeAccent(inputText).toLowerCase())
      : true
  }

  const handleAddDevices = async () => {
    try {
      await insertUserToDevice({
        variables: {
          userToDevices: devicesToAdd.map(device => ({
            userId: patientInfo?.user.id,
            deviceId: device.id,
            doctorId: doctorData?.id
          })),
        },
      });
      setFormSuccess(true);
    } catch (err) {
      console.log(err);
      setFormSuccess(false);
    }
  }

  const handleRemoveDevices = async () => {
    try {
      await deleteUserToDevice({
        variables: {
          deviceId: devicesToRemove.map(device => device.id),
        },
      });
      setFormSuccess(true);
    } catch (err) {
      console.log(err);
      setFormSuccess(false);
    }
  }

  const handleSubmit = () => {
    console.log("moster MF", devicesToAdd.map(device => ({
            userId: patientInfo?.user.id,
            deviceId: device.id,
            doctorId: doctorData?.id
          })));
    console.log("moster MF REMOVE", devicesToRemove.map(device => device.id));
    // if(devicesToAdd.length === 0 && devicesToRemove.length === 0) return;

    if(devicesToAdd.length > 0) {
      handleAddDevices();
    }

    if(devicesToRemove.length > 0) {
      handleRemoveDevices();
    }
  }

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.keyCode === 27) {
        setModalActive(false);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    // Don't forget to clean up
    return function cleanup() {
      document.removeEventListener('keydown', handleKeyDown);
    }
  }, []);  


  if(
    allDevicesDataLoading || 
    allUserToDevicesDataLoading ||
    insertRoleAndDoctorToProcessRoleLoading ||
    deleteUserToDeviceLoading
  ) 
    return(
      <S.ModalSmartDevices>
        <div className="modal-background">
        </div>
        <div className="modal-container">
          <div className="modal-container__reaction">
            <ZaiaReaction
              widthimg={"150px"}
              zaiaImg={logoZaiaLoading}
              padding={"200px 0px"}
            />
          </div>
        </div>
      </S.ModalSmartDevices>
    )

  if(formSuccess)
    return(
      <S.ModalSmartDevices>
        <div className="modal-background" onClick={() => setModalActive(false)}>
        </div>
        <div className="modal-container">
          <div className="modal-container__reaction">
            <ZaiaModalResponseContent
              button1={() => setModalActive(null)}
              formSuccess={formSuccess}
              button1Text={t("globally.done")}
              title={t("profile.smartDevices.devicesUpdated")}
            />
          </div>
        </div>
      </S.ModalSmartDevices>
    )

  if(formSuccess === false)
    return(
      <S.ModalSmartDevices>
        <div className="modal-background" onClick={() => setModalActive(false)}>
        </div>
        <div className="modal-container">
          <div className="modal-container__reaction">
            <ZaiaModalResponseContent
              button1={() => setModalActive(null)}
              formSuccess={formSuccess}
              title={t("globally.errorForm")}
              subtitle={t("profile.smartDevices.errorUpdatingDevices")}
              button1Text={t("globally.accept")}            
            />
          </div>
        </div>
      </S.ModalSmartDevices>
    )

  return (
    <S.ModalSmartDevices>
      <div className="modal-background" onClick={() => setModalActive(false)}>
      </div>
      <div className="modal-container">
        <div className="header">
          <div className="header__text">
            <div className="header__title">{t("profile.smartDevices.title")}</div>
            <div className="header__patient">
              <ZaiaImage
                size={24}
                img={patientInfo.user.picture}
                rounded={true}
              />
              <div className="header__patient-name">{`${patientInfo.user.name} ${patientInfo.user.lastname}`}</div>
              <div className="header__patient-process">{P.dataTranslation(patientInfo?.process?.processName, language)}</div>
            </div>
          </div>
          <div className="header__action" onClick={() => setModalActive(false)}>
            <i className="header__action-icon icon zaia-icono-cerrar"/>
          </div>
        </div>
        <div className="modal-content">
          <div className="modal-content__left">
            <div className="devices-linked">
              <div className="devices-linked__title">
                <div className="title">
                  {t("profile.smartDevices.addedDevices")}
                </div>
              </div>
              <div className="devices-linked__list">
                { currentDevices.length === 0 
                  && <div className="devices-linked__list-empty">
                    {t("profile.smartDevices.noDevicesAdded")}
                  </div>
                }
                { 
                  currentDevices
                  .map((device, index) => {
                    return (   
                      <div
                        key={index}
                        onClick={() => {
                          handleRemoveDevice(device);
                        }}
                      >
                        <DeviceItem
                          device={device}
                          added={true}
                        />
                      </div>
                    )
                  }
                  )
                }
              </div>
            </div>
          </div>
          <div className="modal-content__right">
            <div className="devices-available">
              <div className="devices-available__title">
                <div className="title">
                  {t("profile.smartDevices.availableDevices")}
                </div>
                <div className="searcher">
                  <FlorenzSearchInput
                    placeholder={t("globally.search")}
                    forWhiteBackgroud={true}
                    getText={(text) => setInputText(text)}
                    borderanimation={false}
                  />
                </div>
              </div>
              <div className="devices-available__list">
                { allDevicesDataLoading
                  ? <div className="devices-available__list-loading">
                      <ZaiaReaction
                        widthimg={"100px"}
                        zaiaImg={logoZaiaLoading}
                        padding={"100px 0px"}
                      />
                    </div>
                  : allDevicesDataError
                    ? <div className="devices-available__list-error">
                        <ZaiaReaction
                          widthimg={"150px"}
                          zaiaImg={logoZaiaAlert}
                          padding={"100px 0px"}
                          text={t("profile.smartDevices.errorLoadingDevices")}
                        />
                      </div>
                    : availableDevices?.length === 0
                      ? <div className="devices-available__list-empty">
                          <ZaiaReaction
                            widthimg={"150px"}
                            zaiaImg={eventsCalendarEmpty}
                            padding={"100px 0px"}
                            text={t("profile.smartDevices.noDevicesAvailable")}
                          />
                        </div>
                      : availableDevices?.map((device, index) => 
                        (
                          getFilterText(device?.metadata.device_model) ||
                          getFilterText(device?.metadata.device_type) ||
                          getFilterText(getDeviceName(device?.metadata.device_type))
                        ) &&
                        (
                          <div
                            key={index}
                            onClick={() => {
                              handleAddDevice(device);
                            }} 
                          >
                            <DeviceItem
                              device={device}
                              added={false}
                            />  
                          </div>
                        )
                      )
                }
              </div>
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="button-container">
            <FlorenzButton
              typeStyle={"secondaryWhite"}
              size="s"
              text={t("globally.cancel")}
              widthComplete={true}
              onClick={() => {
                setModalActive(false)
              }}
            />
          </div>
          <div className="button-container">
            <FlorenzButton
              disabled={
                devicesToAdd.length === 0 && devicesToRemove.length === 0
              }
              size="s"
              typeStyle={"success"}
              text={t("globally.save")}
              widthComplete={true}
              icon={
                (devicesToAdd.length === 0 && devicesToRemove.length === 0) && "zaia-i-lock-chat"
              }
              onClick={() => {
                handleSubmit()
              }}
            />
          </div>
        </div>
      </div>
    </S.ModalSmartDevices>
  );
}




export default ModalSmartDevices;
